module.exports = __webpack_public_path__ + "img/sunrise.40a25854.svg";